/**
 * @flow
 * @relayHash f6ef7cc112ea2f78691b8fd68eb3dfce
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type MeasurementUnit = "CM" | "IN" | "%future added value";
export type EditPersonalProfileInput = {|
  userServiceId: string,
  firstName?: ?string,
  lastName?: ?string,
  email?: ?string,
  currency?: ?Currency,
  measurementUnit?: ?MeasurementUnit,
  zipCode?: ?string,
  shareActivities?: ?boolean,
  clientMutationId?: ?string,
|};
export type changeCurrencyMutationVariables = {|
  input: EditPersonalProfileInput
|};
export type changeCurrencyMutationResponse = {|
  +editPersonalProfile: ?{|
    +user: ?{|
      +profile: ?{|
        +currency: ?Currency
      |}
    |}
  |}
|};
export type changeCurrencyMutation = {|
  variables: changeCurrencyMutationVariables,
  response: changeCurrencyMutationResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "EditPersonalProfileInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "EditPersonalProfileInput!"
  }
],
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "profile",
  "storageKey": null,
  "args": null,
  "concreteType": "Profile",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "currency",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "changeCurrencyMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "editPersonalProfile",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "EditPersonalProfilePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "changeCurrencyMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "editPersonalProfile",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "EditPersonalProfilePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "changeCurrencyMutation",
    "id": "dibs-buyer-layout/222.6.0-2019-06-25T11:58:43.302Z/changeCurrencyMutation",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '217dffcd72e935f2b56dd37a4bfdc741';
module.exports = node;
